/**
 * PAY-5625: docked Milo is a sidebar that modals never cover.
 *
 * `--milo-dock-width` (set on `<html>` by `ChatAwareContent` while the panel
 * is docked) is the only source of the width. It is read from `md` up, with a
 * `0px` fallback, so with Milo closed every modal renders exactly as before.
 *
 * - The modal viewport stops at Milo's left edge. `contain: layout` makes it
 *   the popup's containing block, so centring, `w-full` and any call-site
 *   `max-w-*` resolve against the page area beside Milo.
 * - The backdrop still dims the whole screen, Milo's gutters included, by
 *   stretching back past the viewport's right edge (layout containment does
 *   not clip). Milo itself rises above it: see `data-modal-backdrop`.
 */
export const DOCKED_MODAL_VIEWPORT_CLASS =
  'pointer-events-none fixed inset-0 z-50 contain-layout md:right-[var(--milo-dock-width,0px)]';

export const DOCKED_BACKDROP_CLASS =
  'md:right-[calc(var(--milo-dock-width,0px)*-1)]';
